module.exports = __webpack_public_path__ + "static/img/logo@2x.66f85d74.png";